import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class PaymentProviderMethodService {

    constructor(private api: ApiService) {}

    getProviderMethods(query?: any) {
        return this.api.get(this.api.path + '/paymentProviderMethod', query);
    }

    createProviderMethod(data: any) {
        return this.api.post(this.api.path + '/paymentProviderMethod', data);
    }

    updateProviderMethod(id: number, data: any) {
        return this.api.post(this.api.path + '/paymentProviderMethod/' + id, data);
    }

    deleteProviderMethod(id: number) {
        return this.api.delete(this.api.path + '/paymentProviderMethod/' + id);
    }

    getResellerProviderMethods(query?: any) {
        return this.api.get(this.api.path + '/resellerProviderMethod', query);
    }

    createResellerProviderMethod(data: any) {
        return this.api.post(this.api.path + '/resellerProviderMethod', data);
    }

    updateResellerProviderMethod(id: number, data: any) {
        return this.api.post(this.api.path + '/resellerProviderMethod/' + id, data);
    }

    deleteResellerProviderMethod(id: number) {
        return this.api.delete(this.api.path + '/resellerProviderMethod/' + id);
    }
}
